import { Controller } from "@hotwired/stimulus"
import { i18n } from "../lib/i18n"

// Handles radio button visibility selection in forms.
//
// Three modes: organization (single org), network (all orgs), select (specific orgs via modal).
// Listens for "visibility-orgs-selected" event from the org picker modal.
export default class extends Controller {
  static targets = ["gidsField", "orgSummary", "orgCount", "editLink"]
  static values = {
    organizationGid: String,
    networkGid: String,
    mode: String
  }

  connect() {
    this.handleOrgsSelected = this.onOrgsSelected.bind(this)
    window.addEventListener("visibility-orgs-selected", this.handleOrgsSelected)
  }

  disconnect() {
    window.removeEventListener("visibility-orgs-selected", this.handleOrgsSelected)
  }

  selectOrganization() {
    this.gidsFieldTarget.value = this.organizationGidValue
    this.hideSummary()
  }

  selectNetwork() {
    this.gidsFieldTarget.value = this.networkGidValue
    this.hideSummary()
  }

  selectSpecific() {
    this.showSummary()
    // If no orgs selected yet, open the modal automatically
    const currentGids = this.gidsFieldTarget.value
    if (!currentGids || currentGids === this.organizationGidValue || currentGids === this.networkGidValue) {
      this.openPicker()
      if (this.hasEditLinkTarget) this.editLinkTarget.click()
    }
  }

  onOrgsSelected(event) {
    const { gids } = event.detail
    this.gidsFieldTarget.value = gids

    // Check the "select" radio
    const selectRadio = this.element.querySelector("input[value='select']")
    if (selectRadio) selectRadio.checked = true

    this.showSummary()
    this.updateCount(gids)
  }

  showSummary() {
    if (this.hasOrgSummaryTarget) {
      this.orgSummaryTarget.classList.remove("hidden")
    }
  }

  hideSummary() {
    if (this.hasOrgSummaryTarget) {
      this.orgSummaryTarget.classList.add("hidden")
    }
  }

  updateCount(gids) {
    if (!this.hasOrgCountTarget) return

    const count = gids.split(",").filter(Boolean).length
    this.orgCountTarget.textContent = i18n.t("visible_to_radio.organizations_selected", { count })
  }

  // Update the edit link href with current GIDs before navigating
  openPicker(event) {
    if (!this.hasEditLinkTarget) return

    const url = new URL(this.editLinkTarget.href)
    url.searchParams.set("selected_gids", this.gidsFieldTarget.value)
    this.editLinkTarget.href = url.toString()
  }
}
